var CreateTeamStrings = {
    formTitle: function () { return 'Tell us about your company'; },
    companyName: function () { return 'Company Name'; },
    country: function () { return 'Country'; },
    countryOptions: function () { return 'Country Options'; },
    createCompnay: function () { return 'Create Company'; },
    errorBannerTitle: function () { return 'We encountered an unexpected error'; },
    pollingText1: function () { return 'We are creating the company for you'; },
    pollingText2: function () { return 'We are still working on it...'; },
    companyNameRequiredError: function () { return 'A company name is required'; },
    legalTermUnselectedError: function () { return 'You need to agree to the documents above'; },
};
export default CreateTeamStrings;
